<template>
  <svg class="logo" viewBox="0 0 1163 936" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>Click to See the Clouds</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="cloud-bg-icon" transform="translate(-1.000000,
       0.000000)">
        <path class="logo__one" d="M738.57069,
        257.610478 L773.928017,
        257.610478 L874.903448,
        156.653777 L880,
        113.659598 C692.064655,
        -52.2660844 404.746552,
        -34.4314621 238.790086,
        153.469023 C192.602586,
        205.698988 159.156466,
        267.801691 141,
        335 C152.148707,
        330.541344 164.890086,
        329.585918 176.357328,
        332.770672 L378.626724,
        299.330755 C378.626724,
        299.330755 388.819828,
        282.451559 394.234914,
        283.406985 C484.061638,
        184.679612 635.365517,
        173.214498 739.207759,
        257.292003 L738.57069,
        257.610478 Z" id="Path" fill="#F68D12" fill-rule="nonzero"></path>
        <path class="logo__two" d="M1018.36413,
        335.427996 C994.947803,
        249.724211 946.832073,
        172.941265 880.111594,
        114 L737.368261,
        255.777638 C797.67331,
        304.842258 831.995864,
        378.43919 830.712778,
        455.859338 L830.712778,
        481.028851 C900.961744,
        481.028851 957.738305,
        537.421305 957.738305,
        607.195019 C957.738305,
        676.968732 900.961744,
        733.361186 830.712778,
        733.361186 L588,
        733.48877 L551,
        758.849301 L551,
        910.822184 L588,
        935.642465 L830.712778,
        935.991698 C1013.23178,
        937.266103 1162.39054,
        791.665248 1164.0055,
        610.062431 C1164.63594,
        500.144937 1110.10478,
        396.918073 1018.36413,
        335.427996 Z" id="Path" fill="#4267B2" fill-rule="nonzero"></path>
        <path class="logo__three" d="M327.491779,
        270.993706 C146.251611,
        271.969143 0.049085542,
        421.936269 0.995387561,
        605.444431 C1.64170565,
        708.002595 48.7832607,
        804.43307 129.051314,
        867 C209.319367,
        929.56693 269.493877,
        935.645373 327.491779,
        935.645373 C367.986227,
        935.645373 455.155634,
        935.763582 589,
        936 L588,
        839 L588,
        733.48877 C447.731045,
        735.628443 360.894971,
        735.628443 327.491779,
        733.48877 C299.943718,
        731.724154 280.166573,
        720.432866 275.572364,
        718.645423 C210.906905,
        693.486403 183.837446,
        613.82969 212.504607,
        549.65021 C241.171769,
        485.47073 316.024914,
        456.767344 379.411194,
        485.79324 C407.441308,
        498.693638 429.73799,
        521.269334 442.47895,
        549.65021 L589,
        401.295633 C526.887816,
        318.733086 430.056514,
        270.679103 327.491779,
        270.993706 Z" id="Path" fill="#34A853" fill-rule="nonzero"></path>
        <g id="Amazon" transform="translate(772.903806,
         155.696699) rotate(-45.000000) translate(-772.903806,
         -155.696699) translate(691.903806,
         132.696699)" fill="#FFFFFF" font-family="Futura-Bold,
         Futura" font-size="36" font-weight="bold">
            <text>
                <tspan x="0.238" y="37">Amazon</tspan>
            </text>
        </g>
        <text id="Facebook" fill="#FFFFFF" font-family="Futura-Bold,
         Futura" font-size="36" font-weight="bold">
            <tspan x="610.278" y="853">Facebook</tspan>
        </text>
        <g id="Google" transform="translate(481.903806,
         434.696699) rotate(-45.000000) translate(-481.903806,
         -434.696699) translate(409.903806,
         411.696699)" fill="#FFFFFF" font-family="Futura-Bold,
         Futura" font-size="36" font-weight="bold">
            <text>
                <tspan x="0.454" y="37">Google</tspan>
            </text>
        </g>
        <text id="WHERE’S-CLOUD?" font-family="Futura-Bold, Futura" font-size="50" font-weight="bold" fill="#000000">
          <tspan x="400.675" y="685" fill="#000000">WHERE’S </tspan>
          <tspan x="660.925" y="685" fill="#00BAFF">CLOUD</tspan>
          <tspan x="855.425" y="685" fill="#000000">?</tspan>
        </text>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Logo'
};
</script>

<style lang='scss'>
.logo {
  width: 50%;
  height: 70%;
}
</style>
